define(["require", "exports", "tslib", "mobx-react", "react"], function (require, exports, tslib_1, mobx_react_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HGroup = void 0;
    React = tslib_1.__importStar(React);
    exports.HGroup = (0, mobx_react_1.observer)((props) => {
        return React.createElement("div", { id: props.id, className: "HGroup " + (props.className || ""), style: props.style, onClick: props.onClick, onDoubleClick: props.onDoubleClick, onMouseEnter: props.onMouseEnter }, props.children);
    });
});
